import React from "react";

interface SubmitButtonProps {
    isLoading?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    children?: React.ReactNode;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isLoading, disabled, onClick, children }) => {
    return (
        <button
            type="submit"
            onClick={onClick}
            disabled={disabled || isLoading}
            className="flex-1 text-center success w-full"
        >
            {isLoading ? "Submitting..." : children || "Submit"}
        </button>
    );
};

export default SubmitButton;
